module.exports = __webpack_public_path__ + "static/media/20x30.9978ae82.png";